<template>
  <div class="ins-main platform-area">
    <div class="groupHeading header">
      {{ $t('lang_groupHeading_templates') }}
    </div>
    <div class="platformShow-box" id="plat-detail">
      <div class="dtl-top">
        <div class="wrapper clearfix">
          <div class="pcView"><i class="demo-next-ico nextDemo_btn" v-show="nextBtn" @click="changePage('next')"></i><i
              class="demo-prev-ico prevDemo_btn" v-show="prevBtn" @click="changePage('prev')"></i></div>
          <div class="dtl-view">
            <img :src='fileUrl(`${dataInfo.innerSmall[colorChoose] ? dataInfo.innerSmall[colorChoose].img : dataInfo.innerSmall[0].img}`)'>
          </div>
          <div class="dtl-info">
            <div class="titleNum">
              <span>{{ $t('lang_template_ver') }}</span><span>{{ 10 > (dataIndex + 1) ? '0' + (dataIndex + 1) :
                dataIndex + 1
                }}</span>
            </div>
            <div class="infoIns">
              <div class="title">{{ $t('lang_template_desc') }}</div>
              <ul>
                <li> {{ $t("lang_platfrom_narr1") }}</li>
                <li> {{ $t("lang_platfrom_narr2") }}</li>
                <li> {{ $t("lang_platfrom_narr3") }}</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="dtl-show">
        <div class="tab-list">
          <div class="colorChoice">
            <p class="title">顏色</p>
            <ul>
              <li 
                @click="changeColor(index)" 
                :class="{'active': colorChoose === index}" 
                v-for="(color, index) in dataInfo.colors" 
                :key="color"
              >
                <span :style="{backgroundColor: color}"></span>
              </li>
            </ul>
          </div>
          <ul class="imgChoice">
            <li :class="{ 'enable': coverShow === 0 }" @click="changeCover(0)" v-html="$t('lang_platfrom_index')"></li>
            <li :class="{ 'enable': coverShow === 1 }" @click="changeCover(1)" v-html="$t('lang_platfrom_dis')"></li>
          </ul>
        </div>
        <div class="tab-show">
          <ul class="clearfix" :class="{'mobile': dataInfo.device === 'mobile'}">
            <li v-show="coverShow === 0">
              <!-- <img :src='fileUrl(`${dataInfo.innerHomePage[colorChoose].img}`)'> -->
              <img v-for="(img, index) in dataInfo.innerHomePage" :key="index" v-show="colorChoose === index" :src='fileUrl(`${img.img}`)'>
            </li>
            <li v-show="coverShow === 1">
              <!-- <img :src='fileUrl(`${dataInfo.innerPromotion[colorChoose].img}`)'> -->
              <img v-for="(img, index) in dataInfo.innerPromotion" :key="index" v-show="colorChoose === index" :src='fileUrl(`${img.img}`)'>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="mView demoBtn-list">
      <i class="demo-close" @click="closePage"></i>
      <i class="demo-next nextDemo_btn" style="display:block" v-show="nextBtn" @click="changePage('next')"></i>
      <i class="demo-prev prevDemo_btn" style="display:block" v-show="prevBtn" @click="changePage('prev')"></i>
    </div>
  </div>
</template>

<script>
import { BACKEND_LOCATION } from '@api/Endpoints'
import { mapGetters } from 'vuex'
import axios from 'axios'

export default {
  name: 'PlatformShow',
  data() {
    return {
      platformData: [],
      dataID: "",
      dataInfo: {
        id: "",
        sort: "",
        code: "",
        id_tb_language: "",
        id_tb_kind: null,
        device: "",
        colors: [],
        list: "",
        innerSmall: [{ img: "" }],
        innerHomePage: [{ img: "" }],
        innerPromotion: [{ img: "" }]
      },
      dataIndex: 0,
      coverShow: 0,
      prevBtn: false,
      nextBtn: false,
      colorChoose: 0,
    }
  },
  computed: {
    ...mapGetters({
      defLangx: 'defLangx',
      nowLangx: 'nowLangx',
    }),
  },
  methods: {
    changeCover: function (value) {
      this.coverShow = value
    },
    changeColor: function (num) {
      this.colorChoose = num
    },
    changePage: function (str) {
      const index = str === 'next' ? 1 : -1
      const pageID = this.platformData[this.dataIndex + index].id
      this.$router.push({ name: 'platformShow', params: { name: this.$route.params.name, id: pageID } })
    },
    closePage: function () {
      window.close()
    },
    init: function () {
      const that = this
      this.dataID = this.$route.params.id
      this.dataInfo = this.platformData.find(item => item.id === that.dataID && item.device === this.$route.params.name)
      console.log(this.dataInfo)
      //無相符資料時(切換語言時.從網址切換device) 回到列表頁
      if (!this.dataInfo) {
        this.$router.push({ name: 'platformlobby' })
      }

      this.platformData.forEach(function (item, i) {
        if (item.id === that.dataID) { that.dataIndex = i }
      })
      this.prevBtn = this.dataIndex ? true : false
      this.nextBtn = this.dataIndex + 1 !== this.platformData.length
      this.coverShow = 0
      this.colorChoose = 0
    },
    fileUrl(url) {
      const img = url !== 'undefined' && url !== '' ? BACKEND_LOCATION.file + url : false
      return img
    },
    async getPlatformData() {
      try {
        const api = BACKEND_LOCATION.api + 'getdata/platform/' + this.nowLangx + '/device/' + this.$route.params.name
        const res = await axios.post(api)

        if (res.data.code !== "100") {
          throw new Error("Can not get data from getPlatformData function")
        }

        this.platformData = res.data.info.sort(function (a, b) {
          return a.sort - b.sort;
        });

        this.init()
      }
      catch (err) {
        console.error(err)
      }
    }
  },
  created() {
    this.getPlatformData()
  },
  mounted() {
    this.$store.dispatch('setLoadshow', false)
  },
  beforeDestroy() {
    this.$store.dispatch('setLoadshow', true)
  },
  beforeRouteUpdate(to, from, next) {
    next()
    this.init()
  }
}
</script>
<style lang="sass">
  @import '@css/platformShow.sass'
</style>